import {
    ImgByler,
    ImgCabana,
    ImgCapeCottage,
    ImgGardenCottage,
    ImgHeritage,
    ImgHideaway,
    ImgLeanTo,
    ImgModernStudio,
    ImgRancher,
    ImgRetreat,
    ImgTexan,
    ImgVictorianCottage,
    ImgWorkshop,
} from '../../shared/utils/statis-resources.utils';

export type ProductInfo = {
    title: string;
    image: string;
    id: string;
    roofType: string;
    order: number;
};

export const productsList: ProductInfo[] = [
    {
        title: 'The Texan',
        image: ImgTexan,
        id: 'FG-UL-SL-21-BSH',
        roofType: 'Loften',
        order: 2,
    },
    {
        title: 'The Rancher',
        image: ImgRancher,
        id: 'FG-UL-SL-21-CSB',
        roofType: 'Loften',
        order: 6,
    },

    {
        title: 'The Heritage',
        image: ImgHeritage,
        id: 'FG-UL-SL-21-GSH',
        roofType: 'Gable',
        order: 1,
    },

    {
        title: 'The Retreat',
        image: ImgRetreat,
        id: 'FG-UL-SL-21-CSG',
        roofType: 'Gable',
        order: 5,
    },

    {
        title: 'The Workshop',
        image: ImgWorkshop,
        id: 'FG-UL-SL-21-CSW',
        roofType: 'Gable',
        order: 7,
    },
    {
        title: 'The Garden Cottage',
        image: ImgGardenCottage,
        id: 'FG-UL-SL-21-OSH',
        roofType: 'CottageShed',
        order: 3,
    },

    {
        title: 'The Modern Studio',
        image: ImgModernStudio,
        id: 'FG-UL-SL-21-MSH',
        roofType: 'ModernShed',
        order: 4,
    },
    {
        title: 'The Lean To',
        image: ImgLeanTo,
        id: 'FG-UL-SL-21-LTS',
        roofType: 'LeanTo',
        order: 9,
    },
    {
        title: 'The Cabana',
        image: ImgCabana,
        id: 'FG-UL-SL-21-HRS',
        roofType: 'HipRoof',
        order: 8,
    },
    {
        title: 'The Byler',
        image: ImgByler,
        id: 'FG-UL-SL-21-LOW',
        roofType: 'Loften',
        order: 10,
    },
    {
        title: 'The Victorian Cottage',
        image: ImgVictorianCottage,
        id: 'FG-UL-SL-21-VPL',
        roofType: 'VictorianCottage',
        order: 11,
    },
    {
        title: 'The Cape Cottage',
        image: ImgCapeCottage,
        id: 'FG-UL-SL-21-CPL',
        roofType: 'CapeCottage',
        order: 12,
    },
    {
        title: 'The Hideaway',
        image: ImgHideaway,
        id: 'FG-UL-SL-21-HPL',
        roofType: 'Hideaway',
        order: 13,
    },
];
